module.exports = __webpack_public_path__ + "static/media/1021416.80bb50cf.jpg";